var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfileIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 30,
    viewBox: "0 0 22 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.42188 19.6016H16.1079",
    stroke: "#001E64",
    strokeWidth: 1.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.42188 22.4922H16.1079",
    stroke: "#001E64",
    strokeWidth: 1.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 5.3834V24.6169C1 26.7613 2.75762 28.5 4.92569 28.5H17.0746C19.2427 28.5 21 26.7613 21 24.6169V5.3834C21 3.23868 19.2427 1.5 17.0746 1.5H4.92569C2.75762 1.5 1 3.23868 1 5.3834Z",
    stroke: "#001E64",
    strokeWidth: 1.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6992 7.88113C13.6992 9.48716 12.3831 10.7891 10.7596 10.7891C9.1364 10.7891 7.82031 9.48716 7.82031 7.88113C7.82031 6.2751 9.1364 4.97319 10.7596 4.97319C12.3831 4.97319 13.6992 6.2751 13.6992 7.88113Z",
    fill: "#001E64"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1544 15.6094C15.1813 15.4165 15.1947 15.2189 15.1947 15.0186C15.1947 12.5989 13.2114 10.637 10.7653 10.637C8.3189 10.637 6.33594 12.5989 6.33594 15.0186C6.33594 15.2189 6.34935 15.4165 6.37617 15.6094",
    fill: "#001E64"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profileIcon.21ccf3da553a9a8bd23574e173fab95b.svg";
export { ForwardRef as ReactComponent };